module.exports = "mutation ($data: ProductCreate!) {\n  ProductCreate(data: $data) {\n    id\n    gross\n    net\n    isScoped\n  }\n}\n"